import { SingleSubCategory } from '../products/products.type'
import { PublishStatus } from '../shared/shared.type'

export enum CurationPage {
  HOME = 'HOME',
  BROWSE = 'BROWSE',
}

export type HomepageSectionType =
  | 'KITCHENS_NEAR_YOU'
  | 'CATEGORY'
  | 'SUBCATEGORY'
  | 'MANUAL_CURATION'
  | 'AUTOMATED_CURATION'
  | 'CATEGORY_CURATION'
  | 'SUBCATEGORY_CURATION'
  | 'MARKETING_BANNER'

export type HomepageSectionStatus = PublishStatus

export type AutomatedCurationSort =
  | 'newest'
  | 'price_low'
  | 'price_high'
  | 'sales_volume'
  | 'event_date'

export type AutomatedCurationFilters = {
  sort?: AutomatedCurationSort
  maxItems?: number
  salesLookbackDays?: number
  freeOnly?: boolean
}

export type CurationContentType =
  | 'PRODUCTS'
  | 'EVENTS'
  | 'ESSENTIALS'
  | 'GOOD_LISTS'
  | 'LIST_MENUS'
  | 'CREATORS'
  | 'CATEGORIES'
  | 'SUBCATEGORIES'
  | 'MANUAL_ITEM'
  | 'HOMEPAGE_BANNER'

export type HomepageCurationType = {
  _id: string
  name: string
  slug: string
  productSection: 'LIFESTYLE' | 'FOOD' | 'EVENT'
  isActive: boolean
  isDefault: boolean
}

export type HomepageBanner = {
  desktopImage: string
  mobileImage: string
  heading: string
  subtext?: string
  buttonText?: string
  buttonUrl?: string
  secondaryButtonText?: string
  secondaryButtonUrl?: string
  isBackgroundDark: boolean
}

export type HomepageSectionItem = {
  subcategories?: Array<string | SingleSubCategory>
  _id?: string
  type: CurationContentType
  item?: string | Record<string, any>
  homepageBanner?: HomepageBanner
  manualContent?: {
    title: string
    description?: string
    image?: string
    linkUrl?: string
  }
}

export type HomepageSection = {
  page?: CurationPage
  _id: string
  title: string
  description?: string
  sectionType: HomepageSectionType
  stacked?: boolean
  isScrollable?: boolean
  status: HomepageSectionStatus
  order: number
  contentTypes?: CurationContentType[]
  items: HomepageSectionItem[]
  filters?: AutomatedCurationFilters
  subcategoryCuration?: {
    subcategory: string | Record<string, any>
    resolvedSource?: 'OUR_PICKS' | 'ALL_PRODUCTS'
  }
  categoryCuration?: {
    category: string | Record<string, any>
    resolvedSource?: 'OUR_PICKS' | 'ALL_PRODUCTS'
  }
  isTimeScheduled?: boolean
  timeSchedule?: {
    startTime: string
    endTime: string
    slotGroup?: string
  }
}

export type HomepageConfig = {
  sections: HomepageSection[]
  totalSections: number
  publishedSections: number
  draftSections: number
}

export type CreateHomepageSectionPayload = {
  sectionType: HomepageSectionType
  stacked?: boolean
  isScrollable?: boolean
  title: string
  description?: string
  status?: HomepageSectionStatus
  contentTypes?: CurationContentType[]
  items?: HomepageSectionItem[]
  filters?: HomepageSection['filters']
  subcategoryCuration?: HomepageSection['subcategoryCuration']
  categoryCuration?: HomepageSection['categoryCuration']
}

export type TimeSlotGroupPayload = {
  groupName?: string
  targetOrder: number
  sections: Array<{
    sectionId: string
    startTime: string
    endTime: string
  }>
}
